import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/html.svg
 */
const IconHtml: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.928 19.766L3.125 2.016h17.75l-1.803 17.75-6.933 2.218-7.211-2.218zM6.552 5.829h11.045l-.263 2.219H8.99l.208 2.219h7.862l-.787 6.788-4.142 1.012-4.481-1.165-.355-3.377h2.23l.17 1.616 2.453.638 2.099-.513.322-2.78H7.176l-.624-6.657z"
      fill="currentColor"
    />
  </svg>
);

export default IconHtml;
